module.exports = __webpack_public_path__ + "static/media/frames-2.7a7fdb1a.jpg";